import {baseApi} from './baseApi';

export const injectMappingApi = baseApi.injectEndpoints({
    addTagTypes: ['Mapping'],
    endpoints: (builder) => ({
        getPersonenTypes: builder.query({
            query: (args) => {
                const {mappingType} = args;

                let url = 'getPersonenTypes';

                if (mappingType) {
                    url += '?mapping_type=' + mappingType;
                }

                return {url: url};
            },
            providesTags: ['Mapping']
        }),
        getAddressTypes: builder.query({
            query: (args) => {
                return {url: 'getAddressTypes'};
            },
            providesTags: ['Mapping', 'Person']
        }),

        updateMapping: builder.mutation({
            query: (mapping) => ({
                url: 'updateMapping',
                method: 'POST',
                body: mapping,
            }),
            invalidatesTags: ['Mapping', 'Person', 'Parcel', 'LandRegister','Correspondence', 'Contract']
        }),

        deleteMapping: builder.mutation({
            query: (mapping) => ({
                url: 'deleteMapping',
                method: 'DELETE',
                body: mapping,
            }),
            invalidatesTags: ['Mapping', 'Person', 'Parcel', 'LandRegister','Correspondence', 'Contract']
        }),
        setStatus: builder.mutation({
            query: (mapping) => ({
                url: 'setStatus',
                method: 'PUT',
                body: mapping,
            }),
            invalidatesTags: ['Mapping', 'Person', 'Parcel', 'LandRegister','Correspondence', 'Contract']
        }),
    }),
});

export const {
    useGetPersonenTypesQuery,
    useGetAddressTypesQuery,
    useUpdateMappingMutation,
    useDeleteMappingMutation,
    useSetStatusMutation,
} = injectMappingApi;
